"use strict";
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUISchema = exports.updateI18n = exports.setTranslator = exports.setSchema = exports.setLocale = exports.unregisterUISchema = exports.registerUISchema = exports.setValidationMode = exports.setConfig = exports.unregisterRenderer = exports.unregisterCell = exports.registerCell = exports.registerRenderer = exports.updateErrors = exports.update = exports.setAjv = exports.unregisterDefaultData = exports.registerDefaultData = exports.updateCore = exports.init = exports.REMOVE_DEFAULT_DATA = exports.ADD_DEFAULT_DATA = exports.UPDATE_I18N = exports.SET_TRANSLATOR = exports.SET_LOCALE = exports.SET_VALIDATION_MODE = exports.SET_UISCHEMA = exports.SET_SCHEMA = exports.REMOVE_UI_SCHEMA = exports.ADD_UI_SCHEMA = exports.SET_CONFIG = exports.REMOVE_CELL = exports.ADD_CELL = exports.REMOVE_RENDERER = exports.ADD_RENDERER = exports.VALIDATE = exports.UPDATE_ERRORS = exports.UPDATE_DATA = exports.SET_AJV = exports.UPDATE_CORE = exports.INIT = void 0;
var generators_1 = require("../generators");
exports.INIT = 'jsonforms/INIT';
exports.UPDATE_CORE = "jsonforms/UPDATE_CORE";
exports.SET_AJV = 'jsonforms/SET_AJV';
exports.UPDATE_DATA = 'jsonforms/UPDATE';
exports.UPDATE_ERRORS = 'jsonforms/UPDATE_ERRORS';
exports.VALIDATE = 'jsonforms/VALIDATE';
exports.ADD_RENDERER = 'jsonforms/ADD_RENDERER';
exports.REMOVE_RENDERER = 'jsonforms/REMOVE_RENDERER';
exports.ADD_CELL = 'jsonforms/ADD_CELL';
exports.REMOVE_CELL = 'jsonforms/REMOVE_CELL';
exports.SET_CONFIG = 'jsonforms/SET_CONFIG';
exports.ADD_UI_SCHEMA = "jsonforms/ADD_UI_SCHEMA";
exports.REMOVE_UI_SCHEMA = "jsonforms/REMOVE_UI_SCHEMA";
exports.SET_SCHEMA = "jsonforms/SET_SCHEMA";
exports.SET_UISCHEMA = "jsonforms/SET_UISCHEMA";
exports.SET_VALIDATION_MODE = 'jsonforms/SET_VALIDATION_MODE';
exports.SET_LOCALE = "jsonforms/SET_LOCALE";
exports.SET_TRANSLATOR = 'jsonforms/SET_TRANSLATOR';
exports.UPDATE_I18N = 'jsonforms/UPDATE_I18N';
exports.ADD_DEFAULT_DATA = "jsonforms/ADD_DEFAULT_DATA";
exports.REMOVE_DEFAULT_DATA = "jsonforms/REMOVE_DEFAULT_DATA";
var init = function (data, schema, uischema, options) {
    if (schema === void 0) { schema = generators_1.generateJsonSchema(data); }
    return ({
        type: exports.INIT,
        data: data,
        schema: schema,
        uischema: typeof uischema === 'object' ? uischema : generators_1.generateDefaultUISchema(schema),
        options: options
    });
};
exports.init = init;
var updateCore = function (data, schema, uischema, options) { return ({
    type: exports.UPDATE_CORE,
    data: data,
    schema: schema,
    uischema: uischema,
    options: options
}); };
exports.updateCore = updateCore;
var registerDefaultData = function (schemaPath, data) { return ({
    type: exports.ADD_DEFAULT_DATA,
    schemaPath: schemaPath,
    data: data
}); };
exports.registerDefaultData = registerDefaultData;
var unregisterDefaultData = function (schemaPath) { return ({
    type: exports.REMOVE_DEFAULT_DATA,
    schemaPath: schemaPath
}); };
exports.unregisterDefaultData = unregisterDefaultData;
var setAjv = function (ajv) { return ({
    type: exports.SET_AJV,
    ajv: ajv
}); };
exports.setAjv = setAjv;
var update = function (path, updater) { return ({
    type: exports.UPDATE_DATA,
    path: path,
    updater: updater
}); };
exports.update = update;
var updateErrors = function (errors) { return ({
    type: exports.UPDATE_ERRORS,
    errors: errors
}); };
exports.updateErrors = updateErrors;
var registerRenderer = function (tester, renderer) { return ({
    type: exports.ADD_RENDERER,
    tester: tester,
    renderer: renderer
}); };
exports.registerRenderer = registerRenderer;
var registerCell = function (tester, cell) { return ({
    type: exports.ADD_CELL,
    tester: tester,
    cell: cell
}); };
exports.registerCell = registerCell;
var unregisterCell = function (tester, cell) { return ({
    type: exports.REMOVE_CELL,
    tester: tester,
    cell: cell
}); };
exports.unregisterCell = unregisterCell;
var unregisterRenderer = function (tester, renderer) { return ({
    type: exports.REMOVE_RENDERER,
    tester: tester,
    renderer: renderer
}); };
exports.unregisterRenderer = unregisterRenderer;
var setConfig = function (config) { return ({
    type: exports.SET_CONFIG,
    config: config
}); };
exports.setConfig = setConfig;
var setValidationMode = function (validationMode) { return ({
    type: exports.SET_VALIDATION_MODE,
    validationMode: validationMode
}); };
exports.setValidationMode = setValidationMode;
var registerUISchema = function (tester, uischema) {
    return {
        type: exports.ADD_UI_SCHEMA,
        tester: tester,
        uischema: uischema
    };
};
exports.registerUISchema = registerUISchema;
var unregisterUISchema = function (tester) {
    return {
        type: exports.REMOVE_UI_SCHEMA,
        tester: tester
    };
};
exports.unregisterUISchema = unregisterUISchema;
var setLocale = function (locale) { return ({
    type: exports.SET_LOCALE,
    locale: locale
}); };
exports.setLocale = setLocale;
var setSchema = function (schema) { return ({
    type: exports.SET_SCHEMA,
    schema: schema
}); };
exports.setSchema = setSchema;
var setTranslator = function (translator, errorTranslator) { return ({
    type: exports.SET_TRANSLATOR,
    translator: translator,
    errorTranslator: errorTranslator
}); };
exports.setTranslator = setTranslator;
var updateI18n = function (locale, translator, errorTranslator) { return ({
    type: exports.UPDATE_I18N,
    locale: locale,
    translator: translator,
    errorTranslator: errorTranslator
}); };
exports.updateI18n = updateI18n;
var setUISchema = function (uischema) { return ({
    type: exports.SET_UISCHEMA,
    uischema: uischema
}); };
exports.setUISchema = setUISchema;
//# sourceMappingURL=actions.js.map